import AppMenu from './AppMenu'

export default function HeaderWide({ title }) {
  return (
    <>
      <div className="bg-sky-800">
        <AppMenu />
      </div>
    </>
  )
}

